import { render, staticRenderFns } from "./InsertBrand.vue?vue&type=template&id=533555b3&scoped=true&"
import script from "./InsertBrand.vue?vue&type=script&lang=js&"
export * from "./InsertBrand.vue?vue&type=script&lang=js&"
import style0 from "./InsertBrand.vue?vue&type=style&index=0&id=533555b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533555b3",
  null
  
)

export default component.exports